import { privateApi } from 'api'
import { IRichContent, IRichMedia, IRichPromotion } from 'models/richPromotion'

export const richPromotionApi = {
  get: (id: string) => privateApi.get<{ promotion: IRichPromotion | null; content: IRichContent[]; product_id: string; activation_available: boolean }>(`admin/rich-promotions/${id}`),
  save: (id: string, data: Partial<IRichPromotion>) => privateApi.put<IRichPromotion>(`admin/rich-promotions/${id}`, data),
  upload: (id: string, file: File) => {
    const data = new FormData()
    data.append('file', file)
    return privateApi.post<IRichMedia>(`admin/rich-promotions/${id}/media`, data)
  },
  content: (id: string, data: Partial<Omit<IRichContent, 'media'>> & { media: string[] }) => privateApi.post(`admin/rich-promotions/${id}/content`, data),
  removeContent: (id: string, contentId: string) => privateApi.delete(`admin/rich-promotions/${id}/content/${contentId}`)
}
